import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nameFile',
})
export class NameFilePipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): unknown {
    console.log(value.split('\\'));
    if (value) return value.split('\\')[value.split('\\').length - 1];
    return null;
  }
}
